
import { Dropdown } from "react-bootstrap";
import Image from "next/image";
import styles from "./Profile.module.css";

const Profile = (data) => {

  const profileMenu = data?.data?.[0]?.submenu?.results;
  const profileIcon = data?.data?.[0]?.icon?.results?.[0]?.fileUrl;

  return (
    <Dropdown align="end">
      <Dropdown.Toggle
        as="button"
        className={`${styles.profile}`}
        id="profile-dropdown"
      >
        {profileIcon && (
          <Image
            src={profileIcon}
            alt="profile picture"
            height={40}
            width={40}
          />
        )}
      </Dropdown.Toggle>

      <Dropdown.Menu
        className={`${styles.tooltip_style} ${styles.profile_dropdown}`}
      >
        {profileMenu?.map((item, index) => (
          <Dropdown.Item
            key={index}
            className={styles.profile_item}
            href={item?.hyperlink}
          >
            {item?.name}
          </Dropdown.Item>
        ))}
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default Profile;
